import { render, staticRenderFns } from "./StartDemoPopup.vue?vue&type=template&id=b8bfa8c6&scoped=true"
import script from "./StartDemoPopup.vue?vue&type=script&lang=js"
export * from "./StartDemoPopup.vue?vue&type=script&lang=js"
import style0 from "./StartDemoPopup.vue?vue&type=style&index=0&id=b8bfa8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bfa8c6",
  null
  
)

export default component.exports